export default class {
    constructor (lodash, MomentService, SURVEY_PARTICIPANT_STATUS_ENUM) {
        this.MomentService = MomentService;
        this.lodash = lodash;
        this.SURVEY_PARTICIPANT_STATUS_ENUM = SURVEY_PARTICIPANT_STATUS_ENUM;
    }

    convertFormFields (form) {
        if (form.model.formId) {
            form.model.formId = form.model.formId.toString();
        }

        // if deadline given as timestamp, convert it to standard format
        if (form.model.deadline && !isNaN(form.model.deadline)) {
            // we keep standard format in utc timezone
            form.model.deadline = this.MomentService.formatTimeStamp(form.model.deadline, 'YYYY-MM-DD HH:mm:ss', true);
        }
    }

    getStartedParticipants (participants) {
        const statuses = [
            this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.NOT_COMPLETED,
            this.SURVEY_PARTICIPANT_STATUS_ENUM.KEYS.COMPLETED
        ];
        return participants.filter((item) => {
            return this.lodash.includes(statuses, item.status);
        });
    }

    getCKEditorConfig () {
        return {
            toolbar: [
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
                { name: 'links', items: ['Link', 'Unlink'] }
            ],
            removeButtons: 'Cut,Copy,Paste,Undo,Redo,Anchor,About'
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/services/survey/index.js